import { useEffect } from "react";
import { useLocation } from "wouter";
import { recordNavigation } from "@/lib/navigationHistory";

export default function NavigationHistoryTracker() {
  const [location] = useLocation();

  useEffect(() => {
    recordNavigation(location);
  }, [location]);

  return null;
}
